import { Validators } from '@angular/forms';
import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { FormGroupValueOf } from '@utility/utility';
import { maxLengthValidator, notWhitespaceValidator } from '@utility/utility.validators';

export class OtherRequestDetailsFormGroup extends PersistentFormGroup<{
    specialRequests: PersistentFormControl<string | null>;
}> {
    public static create(value: FormGroupValueOf<OtherRequestDetailsFormGroup>): OtherRequestDetailsFormGroup {
        return new OtherRequestDetailsFormGroup({
            specialRequests: new PersistentFormControl(value.specialRequests, [
                Validators.required,
                notWhitespaceValidator(),
                maxLengthValidator(1000),
            ]),
        });
    }
}
